module.exports = __webpack_public_path__ + "static/media/democratic-republic-of-congo.e794ff52.png";